class ApiError extends Error {
  constructor(data, status) {
      super(data.message ? data.message : 'An error occurred')
      this.code = data.code ? data.code : -1
      this.status = status
  }
}

function parseResponse(promise) {
  return promise.then(data => {
    return Object.assign({}, data.data, {status: data.status})
  })
  .catch(e => {
      if (e.response && e.response.status != 200) {
        throw new ApiError(e.response.data, e.response.status)
      }
      throw e
  });
}

export { ApiError,  parseResponse}